// Industry options for business domain
export const INDUSTRIES = [
  { value: 'financial-services', label: 'Financial Services' },
  { value: 'healthcare', label: 'Healthcare' },
  { value: 'retail', label: 'Retail' },
  { value: 'manufacturing', label: 'Manufacturing' },
  { value: 'technology', label: 'Technology' },
  { value: 'telecommunications', label: 'Telecommunications' },
  { value: 'energy', label: 'Energy & Utilities' },
  { value: 'transportation', label: 'Transportation & Logistics' },
  { value: 'media', label: 'Media & Entertainment' },
  { value: 'government', label: 'Government & Public Sector' },
  { value: 'education', label: 'Education' },
  { value: 'other', label: 'Other' },
];

// Company size options
export const COMPANY_SIZES = [
  { value: 'startup', label: 'Startup (1-50 employees)' },
  { value: 'small', label: 'Small (51-200 employees)' },
  { value: 'medium', label: 'Medium (201-1000 employees)' },
  { value: 'large', label: 'Large (1001-5000 employees)' },
  { value: 'enterprise', label: 'Enterprise (5000+ employees)' },
];

// Geographic scope options
export const GEOGRAPHIC_SCOPES = [
  { value: 'local', label: 'Local' },
  { value: 'regional', label: 'Regional' },
  { value: 'national', label: 'National' },
  { value: 'international', label: 'International' },
  { value: 'global', label: 'Global' },
];

// Enterprise system types
export const SYSTEM_TYPES = [
  { value: 'erp', label: 'ERP (Enterprise Resource Planning)' },
  { value: 'crm', label: 'CRM (Customer Relationship Management)' },
  { value: 'scm', label: 'SCM (Supply Chain Management)' },
  { value: 'hrm', label: 'HRM (Human Resource Management)' },
  { value: 'bi', label: 'BI (Business Intelligence)' },
  { value: 'ecommerce', label: 'E-commerce Platform' },
  { value: 'cms', label: 'CMS (Content Management System)' },
  { value: 'database', label: 'Database' },
  { value: 'api', label: 'API Service' },
  { value: 'other', label: 'Other' },
];

// Integration methods
export const INTEGRATION_METHODS = [
  { value: 'rest-api', label: 'REST API' },
  { value: 'graphql', label: 'GraphQL' },
  { value: 'soap', label: 'SOAP' },
  { value: 'webhook', label: 'Webhook' },
  { value: 'file-transfer', label: 'File Transfer (FTP/SFTP)' },
  { value: 'database', label: 'Direct Database Connection' },
  { value: 'message-queue', label: 'Message Queue' },
  { value: 'etl', label: 'ETL Pipeline' },
  { value: 'other', label: 'Other' },
];

// Executive roles
export const EXECUTIVE_ROLES = [
  { value: 'ceo', label: 'CEO (Chief Executive Officer)' },
  { value: 'cfo', label: 'CFO (Chief Financial Officer)' },
  { value: 'cto', label: 'CTO (Chief Technology Officer)' },
  { value: 'cio', label: 'CIO (Chief Information Officer)' },
  { value: 'coo', label: 'COO (Chief Operating Officer)' },
  { value: 'cpo', label: 'CPO (Chief Product Officer)' },
  { value: 'cmo', label: 'CMO (Chief Marketing Officer)' },
  { value: 'chro', label: 'CHRO (Chief Human Resources Officer)' },
  { value: 'cdo', label: 'CDO (Chief Data Officer)' },
  { value: 'vp-sales', label: 'VP of Sales' },
  { value: 'vp-engineering', label: 'VP of Engineering' },
  { value: 'director', label: 'Director' },
  { value: 'manager', label: 'Manager' },
  { value: 'other', label: 'Other' },
];

// KPI categories
export const KPI_CATEGORIES = [
  { value: 'financial', label: 'Financial' },
  { value: 'operational', label: 'Operational' },
  { value: 'customer', label: 'Customer' },
  { value: 'employee', label: 'Employee' },
  { value: 'product', label: 'Product' },
  { value: 'marketing', label: 'Marketing' },
  { value: 'sales', label: 'Sales' },
  { value: 'compliance', label: 'Compliance' },
];

// Project statuses (matching backend enum values)
export const CASE_STATUSES = [
  { value: 'Draft', label: 'Draft', color: 'secondary' },
  { value: 'Processing', label: 'Processing', color: 'warning' },
  { value: 'Completed', label: 'Completed', color: 'success' },
] as const;

// Processing stages
export const PROCESSING_STAGES = [
  { value: 'research', label: 'Research & Analysis' },
  { value: 'schema', label: 'Schema Generation' },
  { value: 'loaders', label: 'Data Loaders' },
  { value: 'analytics', label: 'Analytics Pack' },
  { value: 'complete', label: 'Complete' },
] as const;
